import React from 'react'
import classnames from 'classnames'
import PropTypes from 'prop-types'
import Typography from 'components/atoms/Typography'
import PublishedAt from 'components/molecules/PublishedAt'
import HtmlParser from 'react-html-parser'
import { Col, Container, Row } from 'react-bootstrap'
import { get, isEmpty } from 'lodash'

import './NewsBlock.scss'

function NewsBlock({ className, text, downloads, created, updated, hasGallery=false }) {

  return (
    <div className={classnames('news section-spacing', className)}>
      <div className="news__description text-gray-100 mb-4">{text}</div>

      {downloads && !isEmpty(downloads) && (
        <Container fluid className={classnames('news section-spacing', className)}>
          <Container>
            {downloads?.map(({ entity }, index) => {
              const documentPath = get(entity, 'fieldMediaDocument.entity.url')
              const extension = documentPath?.split('.').pop()
              const documentUrl = get(entity, 'fieldMediaDocument.entity.url')
              const documentName = get(entity, 'title')
              if (entity) {
                return (
                  <Row key={documentName + index} className="news__row py-3 mx-0 d-flex">
                    <Col sm={12} lg={8} className="mb-3 mb-lg-0 px-0 text-gray-100">
                      <Typography className="text">{documentName}</Typography>
                    </Col>
                    {extension == 'pdf' && (
                      <Col xs={6} lg={2} className="px-0">
                        <a href={documentUrl} rel="noopener noreferrer">
                          <Typography cssClass="d-md-flex justify-content-end align-items-center">
                            <i className="icone-eye mr-1" />
                            Visualizar
                          </Typography>
                        </a>
                      </Col>
                    )}
                    <Col xs={6} lg={2} className="px-0">
                      <a href={documentPath} target="_blank" download={documentName} rel="noopener noreferrer">
                        <Typography cssClass="d-md-flex justify-content-end align-items-center">
                          <i className="icone-download mr-1" />
                          Download
                        </Typography>
                      </a>
                    </Col>
                  </Row>
                )
              }
            })}
          </Container>
        </Container>
      )}

      {!hasGallery && (<PublishedAt created={created} updated={updated} />)}
    </div>
  )
}

NewsBlock.defaultProps = {
  hasGallery: false,
}

NewsBlock.propTypes = {
  className: PropTypes.string,
  created: PropTypes.string,
  hasGallery: PropTypes.bool,
  text: PropTypes.node,
  title: PropTypes.node,
  updated: PropTypes.string,
}

export default NewsBlock
